import { DATA_REQUEST_ASYNC, DATA_UPDATE_REQUEST_ASYNC, VERIFY_DOMAIN_ASYNC } from './constants'

export default function () {
  const initialState = {
    data: {},
    loader: false,
    error: null,
    isMailerDomainVerified: false,
    verifyMailerDomainError: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case DATA_UPDATE_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_UPDATE_REQUEST_ASYNC.SUCCESS:
        return { ...state, error: null, loader: false }
      case DATA_UPDATE_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_UPDATE_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case VERIFY_DOMAIN_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case VERIFY_DOMAIN_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          verifyMailerDomainError: null,
          isMailerDomainVerified: true,
        }
      case VERIFY_DOMAIN_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          verifyMailerDomainError: action.error.response.mailerDomain,
          isMailerDomainVerified: false,
        }
      case VERIFY_DOMAIN_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
        }
      default:
        return state
    }
  }
}
